// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';
import QueryExprListener from './QueryExprListener.js';
import QueryExprVisitor from './QueryExprVisitor.js';

const serializedATN = [4,1,42,168,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,
4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,1,0,1,0,1,
0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,44,
8,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,5,1,108,8,1,10,1,12,1,111,9,1,1,2,1,
2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,2,122,8,2,1,3,1,3,3,3,126,8,3,1,3,1,3,1,
4,1,4,3,4,132,8,4,1,4,1,4,1,5,1,5,1,5,5,5,139,8,5,10,5,12,5,142,9,5,1,6,
1,6,1,6,1,6,1,7,1,7,1,8,1,8,1,8,1,8,1,8,1,9,3,9,156,8,9,1,10,1,10,1,10,5,
10,161,8,10,10,10,12,10,164,9,10,1,11,1,11,1,11,0,1,2,12,0,2,4,6,8,10,12,
14,16,18,20,22,0,1,1,0,30,31,196,0,24,1,0,0,0,2,43,1,0,0,0,4,121,1,0,0,0,
6,123,1,0,0,0,8,129,1,0,0,0,10,135,1,0,0,0,12,143,1,0,0,0,14,147,1,0,0,0,
16,149,1,0,0,0,18,155,1,0,0,0,20,157,1,0,0,0,22,165,1,0,0,0,24,25,3,2,1,
0,25,26,5,0,0,1,26,1,1,0,0,0,27,28,6,1,-1,0,28,29,5,1,0,0,29,30,3,2,1,0,
30,31,5,2,0,0,31,44,1,0,0,0,32,44,3,16,8,0,33,44,3,4,2,0,34,44,3,22,11,0,
35,44,3,6,3,0,36,44,3,8,4,0,37,38,5,7,0,0,38,44,3,2,1,23,39,40,5,8,0,0,40,
44,3,2,1,22,41,42,5,26,0,0,42,44,3,2,1,21,43,27,1,0,0,0,43,32,1,0,0,0,43,
33,1,0,0,0,43,34,1,0,0,0,43,35,1,0,0,0,43,36,1,0,0,0,43,37,1,0,0,0,43,39,
1,0,0,0,43,41,1,0,0,0,44,109,1,0,0,0,45,46,10,20,0,0,46,47,5,12,0,0,47,108,
3,2,1,21,48,49,10,19,0,0,49,50,5,9,0,0,50,108,3,2,1,20,51,52,10,18,0,0,52,
53,5,10,0,0,53,108,3,2,1,19,54,55,10,17,0,0,55,56,5,11,0,0,56,108,3,2,1,
18,57,58,10,16,0,0,58,59,5,7,0,0,59,108,3,2,1,17,60,61,10,15,0,0,61,62,5,
8,0,0,62,108,3,2,1,16,63,64,10,14,0,0,64,65,5,16,0,0,65,108,3,2,1,15,66,
67,10,13,0,0,67,68,5,17,0,0,68,108,3,2,1,14,69,70,10,12,0,0,70,71,5,18,0,
0,71,108,3,2,1,13,72,73,10,11,0,0,73,74,5,19,0,0,74,108,3,2,1,12,75,76,10,
10,0,0,76,77,5,21,0,0,77,108,3,2,1,11,78,79,10,9,0,0,79,80,5,20,0,0,80,108,
3,2,1,10,81,82,10,8,0,0,82,83,5,24,0,0,83,108,3,2,1,9,84,85,10,7,0,0,85,
86,5,25,0,0,86,108,3,2,1,8,87,88,10,6,0,0,88,89,5,13,0,0,89,108,3,2,1,7,
90,91,10,5,0,0,91,92,5,27,0,0,92,108,3,2,1,6,93,94,10,4,0,0,94,95,5,28,0,
0,95,108,3,2,1,5,96,97,10,3,0,0,97,98,5,29,0,0,98,108,3,2,1,4,99,100,10,
2,0,0,100,101,5,5,0,0,101,102,3,2,1,0,102,103,5,6,0,0,103,108,1,0,0,0,104,
105,10,1,0,0,105,106,5,22,0,0,106,108,3,22,11,0,107,45,1,0,0,0,107,48,1,
0,0,0,107,51,1,0,0,0,107,54,1,0,0,0,107,57,1,0,0,0,107,60,1,0,0,0,107,63,
1,0,0,0,107,66,1,0,0,0,107,69,1,0,0,0,107,72,1,0,0,0,107,75,1,0,0,0,107,
78,1,0,0,0,107,81,1,0,0,0,107,84,1,0,0,0,107,87,1,0,0,0,107,90,1,0,0,0,107,
93,1,0,0,0,107,96,1,0,0,0,107,99,1,0,0,0,107,104,1,0,0,0,108,111,1,0,0,0,
109,107,1,0,0,0,109,110,1,0,0,0,110,3,1,0,0,0,111,109,1,0,0,0,112,122,5,
32,0,0,113,122,5,33,0,0,114,122,5,34,0,0,115,122,5,35,0,0,116,122,5,36,0,
0,117,122,5,37,0,0,118,122,5,38,0,0,119,122,5,39,0,0,120,122,5,40,0,0,121,
112,1,0,0,0,121,113,1,0,0,0,121,114,1,0,0,0,121,115,1,0,0,0,121,116,1,0,
0,0,121,117,1,0,0,0,121,118,1,0,0,0,121,119,1,0,0,0,121,120,1,0,0,0,122,
5,1,0,0,0,123,125,5,3,0,0,124,126,3,20,10,0,125,124,1,0,0,0,125,126,1,0,
0,0,126,127,1,0,0,0,127,128,5,4,0,0,128,7,1,0,0,0,129,131,5,3,0,0,130,132,
3,10,5,0,131,130,1,0,0,0,131,132,1,0,0,0,132,133,1,0,0,0,133,134,5,4,0,0,
134,9,1,0,0,0,135,140,3,12,6,0,136,137,5,23,0,0,137,139,3,12,6,0,138,136,
1,0,0,0,139,142,1,0,0,0,140,138,1,0,0,0,140,141,1,0,0,0,141,11,1,0,0,0,142,
140,1,0,0,0,143,144,3,14,7,0,144,145,5,14,0,0,145,146,3,2,1,0,146,13,1,0,
0,0,147,148,3,22,11,0,148,15,1,0,0,0,149,150,5,31,0,0,150,151,5,1,0,0,151,
152,3,18,9,0,152,153,5,2,0,0,153,17,1,0,0,0,154,156,3,20,10,0,155,154,1,
0,0,0,155,156,1,0,0,0,156,19,1,0,0,0,157,162,3,2,1,0,158,159,5,23,0,0,159,
161,3,2,1,0,160,158,1,0,0,0,161,164,1,0,0,0,162,160,1,0,0,0,162,163,1,0,
0,0,163,21,1,0,0,0,164,162,1,0,0,0,165,166,7,0,0,0,166,23,1,0,0,0,9,43,107,
109,121,125,131,140,155,162];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

const sharedContextCache = new antlr4.PredictionContextCache();

export default class QueryExprParser extends antlr4.Parser {

    static grammarFileName = "java-escape";
    static literalNames = [ null, "'('", "')'", "'{'", "'}'", "'['", "']'", 
                            "'+'", "'-'", "'*'", "'/'", "'%'", "'^'", "'&'", 
                            "':'", "'?'", "'<'", "'>'", "'<='", "'>='", 
                            null, null, "'.'", "','" ];
    static symbolicNames = [ null, "LPAREN", "RPAREN", "LBRACE", "RBRACE", 
                             "LBRACKET", "RBRACKET", "PLUS", "MINUS", "MUL", 
                             "DIV", "MOD", "POW", "CONCAT", "COLON", "QMARK", 
                             "LT", "GT", "LTE", "GTE", "NEQ", "EQ", "DOT", 
                             "COMMA", "AND", "OR", "NOT", "WITH", "WITHOUT", 
                             "IN", "ESCAPED_IDENTIFIER", "UNESCAPED_IDENTIFIER", 
                             "NULL", "TRUE", "FALSE", "DATE", "TIME", "DATETIME", 
                             "STRING", "NUMBER", "INTEGER", "WHITESPACE", 
                             "COMMENT" ];
    static ruleNames = [ "rootExpression", "expression", "literal", "list", 
                         "map", "keyValues", "keyValue", "key", "functionCall", 
                         "callArgs", "values", "identifier" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = QueryExprParser.ruleNames;
        this.literalNames = QueryExprParser.literalNames;
        this.symbolicNames = QueryExprParser.symbolicNames;
    }

    get atn() {
        return atn;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 1:
    	    		return this.expression_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    expression_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 20);
    		case 1:
    			return this.precpred(this._ctx, 19);
    		case 2:
    			return this.precpred(this._ctx, 18);
    		case 3:
    			return this.precpred(this._ctx, 17);
    		case 4:
    			return this.precpred(this._ctx, 16);
    		case 5:
    			return this.precpred(this._ctx, 15);
    		case 6:
    			return this.precpred(this._ctx, 14);
    		case 7:
    			return this.precpred(this._ctx, 13);
    		case 8:
    			return this.precpred(this._ctx, 12);
    		case 9:
    			return this.precpred(this._ctx, 11);
    		case 10:
    			return this.precpred(this._ctx, 10);
    		case 11:
    			return this.precpred(this._ctx, 9);
    		case 12:
    			return this.precpred(this._ctx, 8);
    		case 13:
    			return this.precpred(this._ctx, 7);
    		case 14:
    			return this.precpred(this._ctx, 6);
    		case 15:
    			return this.precpred(this._ctx, 5);
    		case 16:
    			return this.precpred(this._ctx, 4);
    		case 17:
    			return this.precpred(this._ctx, 3);
    		case 18:
    			return this.precpred(this._ctx, 2);
    		case 19:
    			return this.precpred(this._ctx, 1);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	rootExpression() {
	    let localctx = new RootExpressionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, QueryExprParser.RULE_rootExpression);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 24;
	        this.expression(0);
	        this.state = 25;
	        this.match(QueryExprParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	expression(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExpressionContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 2;
	    this.enterRecursionRule(localctx, 2, QueryExprParser.RULE_expression, _p);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 43;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,0,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new ParenthesizedExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 28;
	            this.match(QueryExprParser.LPAREN);
	            this.state = 29;
	            this.expression(0);
	            this.state = 30;
	            this.match(QueryExprParser.RPAREN);
	            break;

	        case 2:
	            localctx = new FunctionCallExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 32;
	            this.functionCall();
	            break;

	        case 3:
	            localctx = new LiteralExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 33;
	            this.literal();
	            break;

	        case 4:
	            localctx = new IdentifierExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 34;
	            this.identifier();
	            break;

	        case 5:
	            localctx = new ListExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 35;
	            this.list();
	            break;

	        case 6:
	            localctx = new MapExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 36;
	            this.map();
	            break;

	        case 7:
	            localctx = new UnaryPlusExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 37;
	            localctx.Operator = this.match(QueryExprParser.PLUS);
	            this.state = 38;
	            localctx.Right = this.expression(23);
	            break;

	        case 8:
	            localctx = new UnaryMinusExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 39;
	            localctx.Operator = this.match(QueryExprParser.MINUS);
	            this.state = 40;
	            localctx.Right = this.expression(22);
	            break;

	        case 9:
	            localctx = new UnaryNotExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 41;
	            localctx.Operator = this.match(QueryExprParser.NOT);
	            this.state = 42;
	            localctx.Right = this.expression(21);
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 109;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 107;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new RaiseToExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 45;
	                    if (!( this.precpred(this._ctx, 20))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 20)");
	                    }
	                    this.state = 46;
	                    localctx.Operator = this.match(QueryExprParser.POW);
	                    this.state = 47;
	                    localctx.Right = this.expression(21);
	                    break;

	                case 2:
	                    localctx = new MultiplyExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 48;
	                    if (!( this.precpred(this._ctx, 19))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 19)");
	                    }
	                    this.state = 49;
	                    localctx.Operator = this.match(QueryExprParser.MUL);
	                    this.state = 50;
	                    localctx.Right = this.expression(20);
	                    break;

	                case 3:
	                    localctx = new DivideExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 51;
	                    if (!( this.precpred(this._ctx, 18))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 18)");
	                    }
	                    this.state = 52;
	                    localctx.Operator = this.match(QueryExprParser.DIV);
	                    this.state = 53;
	                    localctx.Right = this.expression(19);
	                    break;

	                case 4:
	                    localctx = new ModExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 54;
	                    if (!( this.precpred(this._ctx, 17))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 17)");
	                    }
	                    this.state = 55;
	                    localctx.Operator = this.match(QueryExprParser.MOD);
	                    this.state = 56;
	                    localctx.Right = this.expression(18);
	                    break;

	                case 5:
	                    localctx = new AddExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 57;
	                    if (!( this.precpred(this._ctx, 16))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 16)");
	                    }
	                    this.state = 58;
	                    localctx.Operator = this.match(QueryExprParser.PLUS);
	                    this.state = 59;
	                    localctx.Right = this.expression(17);
	                    break;

	                case 6:
	                    localctx = new SubtractExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 60;
	                    if (!( this.precpred(this._ctx, 15))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 15)");
	                    }
	                    this.state = 61;
	                    localctx.Operator = this.match(QueryExprParser.MINUS);
	                    this.state = 62;
	                    localctx.Right = this.expression(16);
	                    break;

	                case 7:
	                    localctx = new LessThanExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 63;
	                    if (!( this.precpred(this._ctx, 14))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 14)");
	                    }
	                    this.state = 64;
	                    localctx.Operator = this.match(QueryExprParser.LT);
	                    this.state = 65;
	                    localctx.Right = this.expression(15);
	                    break;

	                case 8:
	                    localctx = new GreaterThanExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 66;
	                    if (!( this.precpred(this._ctx, 13))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 13)");
	                    }
	                    this.state = 67;
	                    localctx.Operator = this.match(QueryExprParser.GT);
	                    this.state = 68;
	                    localctx.Right = this.expression(14);
	                    break;

	                case 9:
	                    localctx = new LessThanOrEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 69;
	                    if (!( this.precpred(this._ctx, 12))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 12)");
	                    }
	                    this.state = 70;
	                    localctx.Operator = this.match(QueryExprParser.LTE);
	                    this.state = 71;
	                    localctx.Right = this.expression(13);
	                    break;

	                case 10:
	                    localctx = new GreaterThanOrEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 72;
	                    if (!( this.precpred(this._ctx, 11))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
	                    }
	                    this.state = 73;
	                    localctx.Operator = this.match(QueryExprParser.GTE);
	                    this.state = 74;
	                    localctx.Right = this.expression(12);
	                    break;

	                case 11:
	                    localctx = new EqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 75;
	                    if (!( this.precpred(this._ctx, 10))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
	                    }
	                    this.state = 76;
	                    localctx.Operator = this.match(QueryExprParser.EQ);
	                    this.state = 77;
	                    localctx.Right = this.expression(11);
	                    break;

	                case 12:
	                    localctx = new NotEqualExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 78;
	                    if (!( this.precpred(this._ctx, 9))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
	                    }
	                    this.state = 79;
	                    localctx.Operator = this.match(QueryExprParser.NEQ);
	                    this.state = 80;
	                    localctx.Right = this.expression(10);
	                    break;

	                case 13:
	                    localctx = new AndExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 81;
	                    if (!( this.precpred(this._ctx, 8))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 8)");
	                    }
	                    this.state = 82;
	                    localctx.Operator = this.match(QueryExprParser.AND);
	                    this.state = 83;
	                    localctx.Right = this.expression(9);
	                    break;

	                case 14:
	                    localctx = new OrExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 84;
	                    if (!( this.precpred(this._ctx, 7))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
	                    }
	                    this.state = 85;
	                    localctx.Operator = this.match(QueryExprParser.OR);
	                    this.state = 86;
	                    localctx.Right = this.expression(8);
	                    break;

	                case 15:
	                    localctx = new ConcatExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 87;
	                    if (!( this.precpred(this._ctx, 6))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
	                    }
	                    this.state = 88;
	                    localctx.Operator = this.match(QueryExprParser.CONCAT);
	                    this.state = 89;
	                    localctx.Right = this.expression(7);
	                    break;

	                case 16:
	                    localctx = new WithExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 90;
	                    if (!( this.precpred(this._ctx, 5))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                    }
	                    this.state = 91;
	                    localctx.Operator = this.match(QueryExprParser.WITH);
	                    this.state = 92;
	                    localctx.Right = this.expression(6);
	                    break;

	                case 17:
	                    localctx = new WithoutExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 93;
	                    if (!( this.precpred(this._ctx, 4))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 4)");
	                    }
	                    this.state = 94;
	                    localctx.Operator = this.match(QueryExprParser.WITHOUT);
	                    this.state = 95;
	                    localctx.Right = this.expression(5);
	                    break;

	                case 18:
	                    localctx = new InExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Left = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 96;
	                    if (!( this.precpred(this._ctx, 3))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 3)");
	                    }
	                    this.state = 97;
	                    localctx.Operator = this.match(QueryExprParser.IN);
	                    this.state = 98;
	                    localctx.Right = this.expression(4);
	                    break;

	                case 19:
	                    localctx = new IndexExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Subject = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 99;
	                    if (!( this.precpred(this._ctx, 2))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 2)");
	                    }
	                    this.state = 100;
	                    this.match(QueryExprParser.LBRACKET);
	                    this.state = 101;
	                    localctx.Key = this.expression(0);
	                    this.state = 102;
	                    this.match(QueryExprParser.RBRACKET);
	                    break;

	                case 20:
	                    localctx = new MemberExprContext(this, new ExpressionContext(this, _parentctx, _parentState));
	                    localctx.Subject = _prevctx;
	                    this.pushNewRecursionContext(localctx, _startState, QueryExprParser.RULE_expression);
	                    this.state = 104;
	                    if (!( this.precpred(this._ctx, 1))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 1)");
	                    }
	                    this.state = 105;
	                    this.match(QueryExprParser.DOT);
	                    this.state = 106;
	                    localctx.Key = this.identifier();
	                    break;

	                } 
	            }
	            this.state = 111;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	literal() {
	    let localctx = new LiteralContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 4, QueryExprParser.RULE_literal);
	    try {
	        this.state = 121;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 32:
	            localctx = new NullLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 112;
	            this.match(QueryExprParser.NULL);
	            break;
	        case 33:
	            localctx = new TrueLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 113;
	            this.match(QueryExprParser.TRUE);
	            break;
	        case 34:
	            localctx = new FalseLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 3);
	            this.state = 114;
	            this.match(QueryExprParser.FALSE);
	            break;
	        case 35:
	            localctx = new DateLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 4);
	            this.state = 115;
	            this.match(QueryExprParser.DATE);
	            break;
	        case 36:
	            localctx = new TimeLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 5);
	            this.state = 116;
	            this.match(QueryExprParser.TIME);
	            break;
	        case 37:
	            localctx = new DateTimeLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 6);
	            this.state = 117;
	            this.match(QueryExprParser.DATETIME);
	            break;
	        case 38:
	            localctx = new StringLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 7);
	            this.state = 118;
	            this.match(QueryExprParser.STRING);
	            break;
	        case 39:
	            localctx = new NumberLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 8);
	            this.state = 119;
	            this.match(QueryExprParser.NUMBER);
	            break;
	        case 40:
	            localctx = new IntegerLiteralContext(this, localctx);
	            this.enterOuterAlt(localctx, 9);
	            this.state = 120;
	            this.match(QueryExprParser.INTEGER);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	list() {
	    let localctx = new ListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, QueryExprParser.RULE_list);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 123;
	        this.match(QueryExprParser.LBRACE);
	        this.state = 125;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if((((_la) & ~0x1f) == 0 && ((1 << _la) & 3288334730) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & 511) !== 0)) {
	            this.state = 124;
	            this.values();
	        }

	        this.state = 127;
	        this.match(QueryExprParser.RBRACE);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	map() {
	    let localctx = new MapContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, QueryExprParser.RULE_map);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 129;
	        this.match(QueryExprParser.LBRACE);
	        this.state = 131;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===30 || _la===31) {
	            this.state = 130;
	            this.keyValues();
	        }

	        this.state = 133;
	        this.match(QueryExprParser.RBRACE);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	keyValues() {
	    let localctx = new KeyValuesContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 10, QueryExprParser.RULE_keyValues);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 135;
	        this.keyValue();
	        this.state = 140;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===23) {
	            this.state = 136;
	            this.match(QueryExprParser.COMMA);
	            this.state = 137;
	            this.keyValue();
	            this.state = 142;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	keyValue() {
	    let localctx = new KeyValueContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, QueryExprParser.RULE_keyValue);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 143;
	        this.key();
	        this.state = 144;
	        this.match(QueryExprParser.COLON);
	        this.state = 145;
	        this.expression(0);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	key() {
	    let localctx = new KeyContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 14, QueryExprParser.RULE_key);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 147;
	        this.identifier();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	functionCall() {
	    let localctx = new FunctionCallContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 16, QueryExprParser.RULE_functionCall);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 149;
	        this.match(QueryExprParser.UNESCAPED_IDENTIFIER);
	        this.state = 150;
	        this.match(QueryExprParser.LPAREN);
	        this.state = 151;
	        this.callArgs();
	        this.state = 152;
	        this.match(QueryExprParser.RPAREN);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	callArgs() {
	    let localctx = new CallArgsContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 18, QueryExprParser.RULE_callArgs);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 155;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if((((_la) & ~0x1f) == 0 && ((1 << _la) & 3288334730) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & 511) !== 0)) {
	            this.state = 154;
	            this.values();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	values() {
	    let localctx = new ValuesContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 20, QueryExprParser.RULE_values);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 157;
	        this.expression(0);
	        this.state = 162;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===23) {
	            this.state = 158;
	            this.match(QueryExprParser.COMMA);
	            this.state = 159;
	            this.expression(0);
	            this.state = 164;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	identifier() {
	    let localctx = new IdentifierContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 22, QueryExprParser.RULE_identifier);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 165;
	        _la = this._input.LA(1);
	        if(!(_la===30 || _la===31)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

QueryExprParser.EOF = antlr4.Token.EOF;
QueryExprParser.LPAREN = 1;
QueryExprParser.RPAREN = 2;
QueryExprParser.LBRACE = 3;
QueryExprParser.RBRACE = 4;
QueryExprParser.LBRACKET = 5;
QueryExprParser.RBRACKET = 6;
QueryExprParser.PLUS = 7;
QueryExprParser.MINUS = 8;
QueryExprParser.MUL = 9;
QueryExprParser.DIV = 10;
QueryExprParser.MOD = 11;
QueryExprParser.POW = 12;
QueryExprParser.CONCAT = 13;
QueryExprParser.COLON = 14;
QueryExprParser.QMARK = 15;
QueryExprParser.LT = 16;
QueryExprParser.GT = 17;
QueryExprParser.LTE = 18;
QueryExprParser.GTE = 19;
QueryExprParser.NEQ = 20;
QueryExprParser.EQ = 21;
QueryExprParser.DOT = 22;
QueryExprParser.COMMA = 23;
QueryExprParser.AND = 24;
QueryExprParser.OR = 25;
QueryExprParser.NOT = 26;
QueryExprParser.WITH = 27;
QueryExprParser.WITHOUT = 28;
QueryExprParser.IN = 29;
QueryExprParser.ESCAPED_IDENTIFIER = 30;
QueryExprParser.UNESCAPED_IDENTIFIER = 31;
QueryExprParser.NULL = 32;
QueryExprParser.TRUE = 33;
QueryExprParser.FALSE = 34;
QueryExprParser.DATE = 35;
QueryExprParser.TIME = 36;
QueryExprParser.DATETIME = 37;
QueryExprParser.STRING = 38;
QueryExprParser.NUMBER = 39;
QueryExprParser.INTEGER = 40;
QueryExprParser.WHITESPACE = 41;
QueryExprParser.COMMENT = 42;

QueryExprParser.RULE_rootExpression = 0;
QueryExprParser.RULE_expression = 1;
QueryExprParser.RULE_literal = 2;
QueryExprParser.RULE_list = 3;
QueryExprParser.RULE_map = 4;
QueryExprParser.RULE_keyValues = 5;
QueryExprParser.RULE_keyValue = 6;
QueryExprParser.RULE_key = 7;
QueryExprParser.RULE_functionCall = 8;
QueryExprParser.RULE_callArgs = 9;
QueryExprParser.RULE_values = 10;
QueryExprParser.RULE_identifier = 11;

class RootExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_rootExpression;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	EOF() {
	    return this.getToken(QueryExprParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterRootExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitRootExpression(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitRootExpression(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_expression;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class MapExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	map() {
	    return this.getTypedRuleContext(MapContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterMapExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitMapExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitMapExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.MapExprContext = MapExprContext;

class AndExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	AND() {
	    return this.getToken(QueryExprParser.AND, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterAndExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitAndExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitAndExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.AndExprContext = AndExprContext;

class EqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	EQ() {
	    return this.getToken(QueryExprParser.EQ, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.EqualExprContext = EqualExprContext;

class MultiplyExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	MUL() {
	    return this.getToken(QueryExprParser.MUL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterMultiplyExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitMultiplyExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitMultiplyExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.MultiplyExprContext = MultiplyExprContext;

class UnaryNotExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	NOT() {
	    return this.getToken(QueryExprParser.NOT, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterUnaryNotExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitUnaryNotExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitUnaryNotExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.UnaryNotExprContext = UnaryNotExprContext;

class RaiseToExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	POW() {
	    return this.getToken(QueryExprParser.POW, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterRaiseToExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitRaiseToExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitRaiseToExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.RaiseToExprContext = RaiseToExprContext;

class IndexExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Subject = null; // ExpressionContext;
        this.Key = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	LBRACKET() {
	    return this.getToken(QueryExprParser.LBRACKET, 0);
	};

	RBRACKET() {
	    return this.getToken(QueryExprParser.RBRACKET, 0);
	};

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterIndexExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitIndexExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitIndexExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.IndexExprContext = IndexExprContext;

class DivideExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	DIV() {
	    return this.getToken(QueryExprParser.DIV, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterDivideExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitDivideExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitDivideExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.DivideExprContext = DivideExprContext;

class MemberExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Subject = null; // ExpressionContext;
        this.Key = null; // IdentifierContext;
        super.copyFrom(ctx);
    }

	DOT() {
	    return this.getToken(QueryExprParser.DOT, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	identifier() {
	    return this.getTypedRuleContext(IdentifierContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterMemberExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitMemberExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitMemberExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.MemberExprContext = MemberExprContext;

class IdentifierExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	identifier() {
	    return this.getTypedRuleContext(IdentifierContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterIdentifierExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitIdentifierExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitIdentifierExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.IdentifierExprContext = IdentifierExprContext;

class LiteralExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	literal() {
	    return this.getTypedRuleContext(LiteralContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterLiteralExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitLiteralExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitLiteralExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.LiteralExprContext = LiteralExprContext;

class ListExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	list() {
	    return this.getTypedRuleContext(ListContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterListExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitListExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitListExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.ListExprContext = ListExprContext;

class InExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	IN() {
	    return this.getToken(QueryExprParser.IN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterInExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitInExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitInExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.InExprContext = InExprContext;

class LessThanExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	LT() {
	    return this.getToken(QueryExprParser.LT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterLessThanExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitLessThanExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitLessThanExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.LessThanExprContext = LessThanExprContext;

class GreaterThanExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	GT() {
	    return this.getToken(QueryExprParser.GT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterGreaterThanExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitGreaterThanExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitGreaterThanExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.GreaterThanExprContext = GreaterThanExprContext;

class AddExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	PLUS() {
	    return this.getToken(QueryExprParser.PLUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterAddExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitAddExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitAddExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.AddExprContext = AddExprContext;

class NotEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	NEQ() {
	    return this.getToken(QueryExprParser.NEQ, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterNotEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitNotEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitNotEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.NotEqualExprContext = NotEqualExprContext;

class OrExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	OR() {
	    return this.getToken(QueryExprParser.OR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterOrExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitOrExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitOrExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.OrExprContext = OrExprContext;

class WithoutExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	WITHOUT() {
	    return this.getToken(QueryExprParser.WITHOUT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterWithoutExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitWithoutExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitWithoutExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.WithoutExprContext = WithoutExprContext;

class LessThanOrEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	LTE() {
	    return this.getToken(QueryExprParser.LTE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterLessThanOrEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitLessThanOrEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitLessThanOrEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.LessThanOrEqualExprContext = LessThanOrEqualExprContext;

class ConcatExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	CONCAT() {
	    return this.getToken(QueryExprParser.CONCAT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterConcatExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitConcatExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitConcatExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.ConcatExprContext = ConcatExprContext;

class FunctionCallExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	functionCall() {
	    return this.getTypedRuleContext(FunctionCallContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterFunctionCallExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitFunctionCallExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitFunctionCallExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.FunctionCallExprContext = FunctionCallExprContext;

class UnaryPlusExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	PLUS() {
	    return this.getToken(QueryExprParser.PLUS, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterUnaryPlusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitUnaryPlusExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitUnaryPlusExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.UnaryPlusExprContext = UnaryPlusExprContext;

class ParenthesizedExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	LPAREN() {
	    return this.getToken(QueryExprParser.LPAREN, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	RPAREN() {
	    return this.getToken(QueryExprParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterParenthesizedExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitParenthesizedExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitParenthesizedExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.ParenthesizedExprContext = ParenthesizedExprContext;

class SubtractExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	MINUS() {
	    return this.getToken(QueryExprParser.MINUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterSubtractExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitSubtractExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitSubtractExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.SubtractExprContext = SubtractExprContext;

class WithExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	WITH() {
	    return this.getToken(QueryExprParser.WITH, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterWithExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitWithExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitWithExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.WithExprContext = WithExprContext;

class ModExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	MOD() {
	    return this.getToken(QueryExprParser.MOD, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterModExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitModExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitModExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.ModExprContext = ModExprContext;

class UnaryMinusExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	MINUS() {
	    return this.getToken(QueryExprParser.MINUS, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterUnaryMinusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitUnaryMinusExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitUnaryMinusExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.UnaryMinusExprContext = UnaryMinusExprContext;

class GreaterThanOrEqualExprContext extends ExpressionContext {

    constructor(parser, ctx) {
        super(parser);
        this.Left = null; // ExpressionContext;
        this.Operator = null; // Token;
        this.Right = null; // ExpressionContext;
        super.copyFrom(ctx);
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	GTE() {
	    return this.getToken(QueryExprParser.GTE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterGreaterThanOrEqualExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitGreaterThanOrEqualExpr(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitGreaterThanOrEqualExpr(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.GreaterThanOrEqualExprContext = GreaterThanOrEqualExprContext;

class LiteralContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_literal;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class TrueLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	TRUE() {
	    return this.getToken(QueryExprParser.TRUE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterTrueLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitTrueLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitTrueLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.TrueLiteralContext = TrueLiteralContext;

class DateLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	DATE() {
	    return this.getToken(QueryExprParser.DATE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterDateLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitDateLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitDateLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.DateLiteralContext = DateLiteralContext;

class StringLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	STRING() {
	    return this.getToken(QueryExprParser.STRING, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterStringLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitStringLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitStringLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.StringLiteralContext = StringLiteralContext;

class DateTimeLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	DATETIME() {
	    return this.getToken(QueryExprParser.DATETIME, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterDateTimeLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitDateTimeLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitDateTimeLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.DateTimeLiteralContext = DateTimeLiteralContext;

class NullLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NULL() {
	    return this.getToken(QueryExprParser.NULL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterNullLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitNullLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitNullLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.NullLiteralContext = NullLiteralContext;

class TimeLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	TIME() {
	    return this.getToken(QueryExprParser.TIME, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterTimeLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitTimeLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitTimeLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.TimeLiteralContext = TimeLiteralContext;

class NumberLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NUMBER() {
	    return this.getToken(QueryExprParser.NUMBER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterNumberLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitNumberLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitNumberLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.NumberLiteralContext = NumberLiteralContext;

class IntegerLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	INTEGER() {
	    return this.getToken(QueryExprParser.INTEGER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterIntegerLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitIntegerLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitIntegerLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.IntegerLiteralContext = IntegerLiteralContext;

class FalseLiteralContext extends LiteralContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	FALSE() {
	    return this.getToken(QueryExprParser.FALSE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterFalseLiteral(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitFalseLiteral(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitFalseLiteral(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}

QueryExprParser.FalseLiteralContext = FalseLiteralContext;

class ListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_list;
    }

	LBRACE() {
	    return this.getToken(QueryExprParser.LBRACE, 0);
	};

	RBRACE() {
	    return this.getToken(QueryExprParser.RBRACE, 0);
	};

	values() {
	    return this.getTypedRuleContext(ValuesContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitList(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitList(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class MapContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_map;
    }

	LBRACE() {
	    return this.getToken(QueryExprParser.LBRACE, 0);
	};

	RBRACE() {
	    return this.getToken(QueryExprParser.RBRACE, 0);
	};

	keyValues() {
	    return this.getTypedRuleContext(KeyValuesContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterMap(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitMap(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitMap(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class KeyValuesContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_keyValues;
    }

	keyValue = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(KeyValueContext);
	    } else {
	        return this.getTypedRuleContext(KeyValueContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(QueryExprParser.COMMA);
	    } else {
	        return this.getToken(QueryExprParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterKeyValues(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitKeyValues(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitKeyValues(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class KeyValueContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_keyValue;
    }

	key() {
	    return this.getTypedRuleContext(KeyContext,0);
	};

	COLON() {
	    return this.getToken(QueryExprParser.COLON, 0);
	};

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterKeyValue(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitKeyValue(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitKeyValue(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class KeyContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_key;
    }

	identifier() {
	    return this.getTypedRuleContext(IdentifierContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterKey(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitKey(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitKey(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class FunctionCallContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_functionCall;
    }

	UNESCAPED_IDENTIFIER() {
	    return this.getToken(QueryExprParser.UNESCAPED_IDENTIFIER, 0);
	};

	LPAREN() {
	    return this.getToken(QueryExprParser.LPAREN, 0);
	};

	callArgs() {
	    return this.getTypedRuleContext(CallArgsContext,0);
	};

	RPAREN() {
	    return this.getToken(QueryExprParser.RPAREN, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterFunctionCall(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitFunctionCall(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitFunctionCall(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class CallArgsContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_callArgs;
    }

	values() {
	    return this.getTypedRuleContext(ValuesContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterCallArgs(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitCallArgs(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitCallArgs(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class ValuesContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_values;
    }

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(QueryExprParser.COMMA);
	    } else {
	        return this.getToken(QueryExprParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterValues(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitValues(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitValues(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}



class IdentifierContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = QueryExprParser.RULE_identifier;
    }

	ESCAPED_IDENTIFIER() {
	    return this.getToken(QueryExprParser.ESCAPED_IDENTIFIER, 0);
	};

	UNESCAPED_IDENTIFIER() {
	    return this.getToken(QueryExprParser.UNESCAPED_IDENTIFIER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.enterIdentifier(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof QueryExprListener ) {
	        listener.exitIdentifier(this);
		}
	}

	accept(visitor) {
	    if ( visitor instanceof QueryExprVisitor ) {
	        return visitor.visitIdentifier(this);
	    } else {
	        return visitor.visitChildren(this);
	    }
	}


}




QueryExprParser.RootExpressionContext = RootExpressionContext; 
QueryExprParser.ExpressionContext = ExpressionContext; 
QueryExprParser.LiteralContext = LiteralContext; 
QueryExprParser.ListContext = ListContext; 
QueryExprParser.MapContext = MapContext; 
QueryExprParser.KeyValuesContext = KeyValuesContext; 
QueryExprParser.KeyValueContext = KeyValueContext; 
QueryExprParser.KeyContext = KeyContext; 
QueryExprParser.FunctionCallContext = FunctionCallContext; 
QueryExprParser.CallArgsContext = CallArgsContext; 
QueryExprParser.ValuesContext = ValuesContext; 
QueryExprParser.IdentifierContext = IdentifierContext; 
